/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Notify_DescInputs */

const en_fw_notify_desc = /** @type {(inputs: Fw_Notify_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get told when a checkpoint needs you, a task finishes, an agent gets stuck, or someone comments.`)
};

const id_fw_notify_desc = /** @type {(inputs: Fw_Notify_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamu dikabari otomatis saat ada checkpoint yang menunggumu, task selesai, agen tersangkut, atau ada komentar.`)
};

/**
* | output |
* | --- |
* | "Get told when a checkpoint needs you, a task finishes, an agent gets stuck, or someone comments." |
*
* @param {Fw_Notify_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_notify_desc = /** @type {((inputs?: Fw_Notify_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Notify_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_notify_desc(inputs)
	return en_fw_notify_desc(inputs)
});